$(document).ready(function () {
    var prodid = $(".prodid").val();
    var bakilanurun = Vivense.cookie.get("skubak");
    var shwbak = Vivense.cookie.get("shwbak");

    if (!bakilanurun) {
        Vivense.cookie.set("skubak", prodid, 7 * 24); // 1 week
    } else {
        var bakilanarray = bakilanurun.split(',');
        if (bakilanarray.indexOf(prodid) == -1 && bakilanarray.length <= 4) {
            Vivense.cookie.set("skubak",  bakilanurun + ',' + prodid, 7 * 24); // 1 week
            bakilanarray.push(prodid);
        }
        if (bakilanarray.length >= 4 && shwbak == 1) {
            Vivense.cookie.set("showroomconversion2", 1, 7 * 24); // 1 week
            Vivense.cookie.delete("skubak");
            Vivense.cookie.delete("shwbak");
        } else {
            Vivense.cookie.delete("showroomconversion2");
        }
    }

});